import React from "react";
import classNames from "classnames";
import { Icon } from "../../Icon";
import {
  ComponentElementsIconTextList,
  Enum_Componentelementsparagraph_Size,
} from "../../../graphql/generated/graphql";
import { notEmpty } from "../../../utils/notEmpty";
import { Paragraph } from "../Paragraph";

interface IIconWithTextList {
  direction: "horizontal" | "vertical";
  variant: "default" | "streched";
  items?: (ComponentElementsIconTextList | null)[] | null; // TODO: fix
  textClassName?: string;
  iconClassName?: string;
}

export function IconWithTextList({
  variant,
  direction,
  items = [],
  iconClassName = "w-5 h-5",
  textClassName = "",
}: IIconWithTextList): JSX.Element {
  return (
    <ul
      className={classNames({
        "flex gap-8 items-center": direction === "horizontal",
        "space-y-2": direction === "vertical",
        "justify-around": variant === "streched",
        [`${textClassName}`]: Boolean(textClassName),
      })}
    >
      {items?.filter(notEmpty).map((item) => {
        return (
          <li key={item.id} className={`flex gap-2 items-center`}>
            {item.icon && (
              <Icon
                className={iconClassName}
                name={item.icon?.data?.attributes?.value}
                variant={item.variant}
              />
            )}
            <Paragraph
              containerClassName="text-inherit"
              size={Enum_Componentelementsparagraph_Size.Small}
            >
              {item.text}
            </Paragraph>
          </li>
        );
      })}
    </ul>
  );
}
